<template>
    <b-container class="pt-2">
        <b-row>
            <b-col>
                <image-carousel class="mb-4 mt-4 shadow-lg" :images="heroes"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="12" lg="8">
                <image-carousel class="mb-4 shadow" :images="getNewsImages"/>
            </b-col>
            <b-col cols="12" md="12" lg="4" class="mb-4">
                <b-card overlay
                      :img-src="connectBackground"
                      img-alt="Portal Background"
                      text-variant="white"
                      title="MQA Portal"
                      img-fluid
                      class="text-center shadow"
                >
                    <div class="d-inline-flex h-100 w-100 align-items-end justify-content-between pb-4">
                        <b-link class="btn btn-success">Register</b-link>
                        <b-link class="btn btn-primary">Login</b-link>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="12" lg="3" class="mt-2">
                <b-card title="Circulars" no-body>
                    <h4 slot="header">Circulars</h4>
                    <b-list-group flush v-for="circular in circulars">
                        <b-list-group-item :href="circular.path" target="_blank">{{ circular.name }}</b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
            <b-col cols="12" md="12" lg="3" class="mt-2">
                <b-card title="Announcements" no-body>
                    <h4 slot="header">Announcements</h4>
                    <b-list-group flush v-for="announcement in announcements">
                        <b-list-group-item :href="announcement.file" target="_blank">{{ announcement.name }}</b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
            <b-col cols="12" md="12" lg="3" class="mt-2">
                <b-card title="Dates" no-body>
                    <h4 slot="header">Dates</h4>
                    <b-list-group flush v-for="date in dates">
                        <b-list-group-item href="#">{{ date.date }}<br>{{ date.name }}</b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
            <b-col cols="12" md="12" lg="3" class="mt-2">
                <b-card>
                    <h4 slot="header">Service Timings</h4>
                    <p class="card-text" v-html="scheduleTimings.value">
                    </p>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from 'axios'
import ImageCarousel from '@/components/SharedComponents/ImageCarousel.vue'
import moment from 'moment'
export default {
    data() {
        return{
            heroes: [],
            articles: [],
            circulars: [],
            news: [],
            announcements: [],
            dates: [],
            scheduleTimings: [],
            connectBackground: null
        }
    },
    computed: {
        getNewsImages() {
            let array = []
            this.news.forEach(element => {
                array.push({
                    image: element.image,
                    file: element.path ? element.path : element.file
                })
            })
            return array
        }
    },
    methods: {
        getHeroes(){
            axios.get(this.API_URL + '/heroes').then((response) => {
                this.heroes = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getArticles(){
            axios.get(this.API_URL + '/articles/latest').then((response) => {
                this.articles = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getAnnouncements(){
            axios.get(this.API_URL + '/announcements/latest').then((response) => {
                this.announcements = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getCirculars(){
            axios.get(this.API_URL + '/circulars/latest').then((response) => {
                this.circulars = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getNews(){
            axios.get(this.API_URL + '/news/latest').then((response) => {
                this.news = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getDates(){
            axios.get(this.API_URL + '/important_dates').then((response) => {
                this.dates = response.data

                this.dates.forEach((element) => {
                    element.date =  moment(element.date).format('MMM Do YYYY')
                })
            }, (error) => {
                console.log(error)
            })
        },
        getScheduleTimings(){
            axios.get(this.API_URL + '/schedule_timings').then((response) => {
                this.scheduleTimings = response.data
            }, (error) => {
                console.log(error)
            })
        },
        getConnectBackground(){
            axios.get(this.API_URL + '/connect_background').then((response) => {
                this.connectBackground = response.data
            }, (error) => {
                console.log(error)
            })
        }
    },
    beforeCreate() {
        document.title = 'Home'
    },
    created() {
        
    },
    beforeMount() {
        this.getArticles()
    },
    mounted() {
        this.getHeroes()
        this.getAnnouncements()
        this.getDates()
        this.getCirculars()
        this.getNews()
        this.getScheduleTimings()
        this.getConnectBackground()
    },
    beforeUpdate() {
        
    },
    updated() {

    },
    components: {
        ImageCarousel
    }
}
</script>
<style scoped>
.card-img-top {
    width: 100%;
    height: 15vw;
    object-fit: cover;
}
body {
    background: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue